import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { showAccessDeniedAlert } from "../../../utils/accessDenied"
import RoutesMap from "../../../route_control/RouteControl"
import axios from "axios"

export const registeredEventList = createAsyncThunk('registeredEventList', async ({ pageable: data, navigate }) => {

    const participant = JSON.parse(localStorage.getItem('user_details'))

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `event_by_participant`,
            params: {
                'participant_code': participant?.participant_code,
            },
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + localStorage.getItem('user_token'),
            }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const registeredEventListSlice = createSlice({
    name: 'registeredEventList',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(registeredEventList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                localStorage.clear()
                action.meta.arg.navigate(RoutesMap.LOGIN.path)
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }

        });
        builder.addCase(registeredEventList.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default registeredEventListSlice.reducer; 